var _style, _polygon, _path, _rect, _path2, _path3, _path4, _polygon2, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 306 76",
    style: {
      enableBackground: "new 0 0 306 76"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0043A5;}\n\t.st1{fill:#1E68FF;}\n\t.st2{fill:#14232B;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.6,47.5 34.1,53.2 23.2,42.3 28.8,36.7 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.1,53.2l-5.8-5.8c0,0,7.2-7.6,10.8-11.1C42.6,32.8,50.8,25,50.8,25l5.8,5.8c0,0-14.5,14.2-11.4,11.1 C48.2,38.8,34.1,53.2,34.1,53.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 16,
    className: "st0",
    width: 30.9,
    height: 7.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.7,29.6c0-5.9-4-10.1-12.2-10.1H76.4v0h-4.8v7.4h4.8v29h9.7V42.7h6.6c3.1,0,5.4,1.6,5.4,5.1v1.5 c0,3,0.2,5.1,0.7,6.6h9.7c-0.4-2.1-0.7-3.6-0.7-6.6v-2c0-5.4-3.2-7.3-6.9-8.1C105.4,38.2,108.7,34.7,108.7,29.6z M94,35.8h-7.8v-8.9 H94c3.2,0,4.6,1.4,4.6,4.3C98.7,34.3,97.3,35.8,94,35.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.5,41.4c0,5.2-2.2,7.8-5.9,7.8c-3.3,0-4.8-2-4.8-5.6v-15h-9.4v16.6c0,7.2,3.2,11.6,10.4,11.6 c4.8,0,7.9-2.3,9.7-5.9v5h9.4V28.5h-9.4V41.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.6,27.6c-4.9,0-8,2.4-9.8,6v-5.1h-9.4v27.3h9.4V43c0-5.4,2.2-7.8,6-7.8c3.3,0,4.8,2,4.8,5.6v15h9.4V39.2 C177.9,32.1,174.7,27.6,167.6,27.6z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "216.5,48.7 210.5,28.5 200.6,28.5 194.5,48.7 189.9,28.5 180.5,28.5 187.2,55.9 200.2,55.9 205.1,37.9  209.9,55.9 222.9,55.9 229.6,28.5 220.9,28.5 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258.6,37.4c0-6.2-4.3-9.8-12.9-9.8c-8.6,0-13.7,4.2-13.9,10h9.1c0.1-2.4,1.6-3.7,4.9-3.7c3.1,0,4.1,1,4.1,2.6 c0,1.4-0.7,2.1-3.2,2.5l-6.2,1.1c-7.5,1.3-9.4,4.2-9.4,8.5c0,4.8,3.6,7.9,9.1,7.9c5.5,0,8.9-2.4,10.3-6.4c0,2.2,0.2,4.1,0.4,5.7h8.1 c-0.3-2.2-0.5-4.6-0.5-7.5V37.4z M249.9,43c0,4.9-2.5,7.4-6.1,7.4c-1.9,0-3.4-1-3.4-2.9c0-1.9,1-2.8,3.6-3.4l1.6-0.4 c1.7-0.4,3-0.8,4.3-1.7V43z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.8,28.5l-5,15.9l-1.4,5.1l-1.6-5.1l-5.3-15.9h-9.6l8.9,26.6h6l-1.4,4.3h-11.8v7.4h7.9 c8.6,0,11.4-3.8,13.6-10.9l8.7-27.4H283.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.9,62.4v-3.6h-7.7c-1.5,0-3-0.3-4.3-0.9c-2-0.8-3.7-2.2-4.9-4c-1.2-1.8-1.9-3.9-1.9-6.2V28.2 c0-1.5,0.3-3,0.9-4.3c0.8-2,2.2-3.7,4-4.9c1.8-1.2,3.9-1.9,6.2-1.9h7.7c1.5,0,3,0.3,4.3,0.9c2,0.8,3.7,2.2,4.9,4 c1.2,1.8,1.9,3.9,1.9,6.2v19.5c0,1.5-0.3,3-0.9,4.3c-0.8,2-2.2,3.7-4,4.9c-1.8,1.2-3.9,1.9-6.2,1.9V62.4v3.6c2.5,0,4.9-0.5,7.1-1.4 c3.3-1.4,6.1-3.7,8-6.6c2-2.9,3.1-6.4,3.1-10.2V28.2c0-2.5-0.5-4.9-1.4-7.1c-1.4-3.3-3.7-6.1-6.6-8c-2.9-2-6.4-3.1-10.2-3.1h-7.7 c-2.5,0-4.9,0.5-7.1,1.4c-3.3,1.4-6.1,3.7-8,6.6c-2,2.9-3.1,6.4-3.1,10.2v19.5c0,2.5,0.5,4.9,1.4,7.1c1.4,3.3,3.7,6.1,6.6,8 c2.9,2,6.4,3.1,10.2,3.1h7.7V62.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunway);
export default __webpack_public_path__ + "static/media/Runway.365afa50448b9128e2cc1e0061c1a75b.svg";
export { ForwardRef as ReactComponent };